module.exports = __webpack_public_path__ + "assets/img/all_award_btn.cefd90f9.png";